module.exports = __webpack_public_path__ + "static/media/esri.1c6bee21.png";